<template>
  <select :data-placeholder="placeholder" :multiple="multiple">
    <option
      v-for="(option, index) in customOptions"
      :value="option.id"
      :key="index"
    >
      {{ option.label }}
    </option>
  </select>
</template>

<script>
import 'chosen-js/chosen.jquery.min.js'
import 'chosen-js/chosen.min.css'
import 'bootstrap-chosen/bootstrap-chosen.css'

export default {
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: null
    },
    options: {
      type: [Array, Object],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select'
    },
    searchable: {
      type: Boolean,
      default: true
    },
    searchableMin: {
      type: Number,
      default: 1
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    customOptions () {
      const options = this.options.map(key => ({
        id: key.id || key.value,
        label: key.short_title || key.carrier_name || key.name || key.title
      }))

      return !this.allowEmpty ? [{ id: null, label: '' }] : options
    },
    localValue () {
      this.nextTick()
      return this.value
    }
  },
  watch: {
    localValue () {},

    customOptions () {
      this.nextTick()
    }
  },
  methods: {
    nextTick () {
      this.$nextTick(function () {
        $(this.$el).val(this.value).trigger('chosen:updated')
      })
    }
  },
  mounted () {
    const vm = this

    $(this.$el).chosen({
      width: '100%',
      disable_search_threshold: this.searchable ? this.searchableMin : 100000
    }).change(function ($event) {
      vm.$emit('input', $($event.target).val())
    })
  }
}
</script>

<style lang="scss">
@import 'chosen';
</style>



// WEBPACK FOOTER //
// src/components/chosen/Chosen.vue